// import Card from './card'
import CustomCardRoot from './CardRoot'
import CustomCardTitle from './CardTitle'
import CustomCardContent from './CardContent'

export const Card = {
  Root: CustomCardRoot,
  Title: CustomCardTitle,
  Content: CustomCardContent,
}
